// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ListItem, { ListItemProps, OrderedList, UnorderedList } from "@insite/mobius/Lists";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

export interface OrderUploadInstructionsStyles {
    wrapper?: InjectableCss;
    lastListItem?: ListItemProps;
    linkStyle?: LinkPresentationProps;
}

export const orderUploadInstructionsStyles: OrderUploadInstructionsStyles = {};

const styles = orderUploadInstructionsStyles;

const OrderUploadInstructions = () => {
    const downloadTemplateHandler = () => {
        window.open(`${window.location.origin}/Excel/OrderUploadTemplate.xlsx`);
    };
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography variant="h3">{translate("Instructions")}</Typography>
            <OrderedList>
                <ListItem>
                    {siteMessage("OrderUpload_Instructions_Line1_Part1")}
                    <Link onClick={downloadTemplateHandler} {...styles.linkStyle}>
                        {translate("Order Upload Template")}
                    </Link>
                    {siteMessage("OrderUpload_Instructions_Line1_Part2")}
                </ListItem>
                <UnorderedList>
                    <ListItem>{siteMessage("OrderUpload_Instructions_Line2")}</ListItem>
                    <ListItem>{siteMessage("OrderUpload_Instructions_Line3")}</ListItem>
                    <ListItem>{siteMessage("OrderUpload_Instructions_Line4")}</ListItem>
                </UnorderedList>
                <ListItem>{siteMessage("OrderUpload_Instructions_Line5")}</ListItem>
                <ListItem>{siteMessage("OrderUpload_Instructions_Line6")}</ListItem>
                <ListItem>{siteMessage("OrderUpload_Instructions_Line7")}</ListItem>
                <ListItem {...styles.lastListItem}>{siteMessage("OrderUpload_Instructions_Line8")}</ListItem>
            </OrderedList>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderUploadInstructions,
    definition: {
        allowedContexts: ["OrderUploadPage", "MyListsDetailsPage"],
        group: "Order UploadPage" as any,
    },
};

export default widgetModule;
